<template>
    <main class="tw-flex tw-min-h-screen tw-flex-col md:tw-flex-row">   
        <div class="pagev2 tw-flex tw-flex-col tw-flex-1">
            <NavBar />
            <div :class="theme === 'dark' ? 'tw-bg-[#151515]' : 'tw-bg-slate-50'" class="tw-flex-1 tw-min-w-0">
                <slot></slot>
            </div>
            <FooTer />
        </div>
    </main>
</template>

<script>
import { mapState } from 'vuex';
import { ref, onMounted, onUnmounted } from 'vue';
import FooTer from '../../ui/v2/FooTer.vue';
import NavBar from "../../ui/v2/NavBar.vue";

export default {
    components: {
        NavBar,
        FooTer
    },
    setup() {
        const isMobile = ref(false);
        const isMobileMenuOpen = ref(false);

        const checkMobile = () => {
            isMobile.value = window.innerWidth <= 1000;
        };

        onMounted(() => {
            checkMobile();
            window.addEventListener('resize', checkMobile);
        });

        onUnmounted(() => {
            window.removeEventListener('resize', checkMobile);
        });

        return {
            isMobile,
            isMobileMenuOpen
        };
    },
    computed: {
        ...mapState('ui', ['isSidebarCollapsed']),
        ...mapState({
            theme: state => state.ui.theme,
        }),
        
    },
}
</script>

<style scoped>
    .layout {
        display: flex;
        flex-direction: column;
        min-height: 100vh;
    }

    .main-content {
        flex: 1;
    }

    @media (max-width: 999px) {
    .pagev2 {
        margin-left: 0;
        width: 100%;
        padding-top: 56px;
    }
}
</style>
